<template>

	<div id="event-calendar" :class="{ 'loading' : loading }">

		<div class="calendar-utils">

			<div class="calendar-controls">

				<div class="month-switcher">

					<a href="#" title="Previous Month" :class="{ 'change-month previous-month' : true, 'disabled' : disablePreviousMonth }" @click.prevent="subtractMonth">

						<span class="text">Previous</span>

					</a>

					<span class="current-month">{{ month }} {{ year }}</span>

					<a href="#" title="Next Month" class="change-month next-month" @click.prevent="addMonth">

						<span class="text">Next</span>

					</a>

					<a href="#" class="change-to-current-month" v-if="! isCurrentMonth" @click.prevent="goToThisMonth">
						Return to current month
					</a>

				</div>

			</div>

			<div class="calendar-keys">

				<span class="key standard">
					<span class="event-icon"></span>
					<span class="key-label">Event by Training Hub</span>
				</span>

				<span class="key partner">
					<span class="event-icon partner"></span>
					<span class="key-label">Partner Event</span>
				</span>

				<span class="key unaffiliated">
					<span class="event-icon unaffiliated"></span>
					<span class="key-label">External Event</span>
				</span>

				<span class="key fully-booked">
					<span class="event-icon fully-booked"></span>
					<span class="key-label">Full Booked</span>
				</span>

			</div>

		</div>

		<div v-if="! loading && ! monthHasEvents()" class="no-events-in-month">
			No Events Found In {{ month }} {{ year }}
		</div>

		<div class="calendar-dates-wrapper">

			<div class="days-header">

				<div v-for="day in days" class="day">
					{{ day }}
				</div>

			</div>

			<div :class="{ 'days': true, 'past-month': isPastMonth }">

				<div id="current-events-panel" class="moved">

					<div class="inner" v-if="hasViewingDay()">

						<div v-if="hasViewingDay()" :class="[{ event: true, 'fully-booked' : event.fully_booked }, event.organiser]" v-for="event in viewingDay.events">

							<a :href="event.url" class="event-link">

								<span class="event-title">
									<span :class="[{ 'event-icon': true, 'fully-booked' : event.fully_booked }, event.organiser]"></span>
									<span class="text">{{ event.title }}</span>
									<span class="price">{{ event.price }}</span>
								</span>

								<span class="view-link">
									<span v-if="event.fully_booked && event.waiting_list_enabled" class="text fully-booked">Join Waiting List</span>
									<span v-else-if="event.fully_booked" class="text fully-booked disabled">Fully Booked</span>
									<span v-else class="text book-now">
										{{ event.book_now_label }}
									</span>
								</span>

							</a>

						</div>

					</div>

				</div>

				<div v-for="blank in firstDayOfMonth"
					 :id="generateDayId( previousMonthObj.format( 'Y' ) + '-' + previousMonthObj.format( 'MMMM' ) + '-' + ( previousMonthMaxDays() - ( firstDayOfMonth - blank ) ) )"
					 class="day-col filler-day" @click.prevent="subtractMonth">

					<span class="day-num">{{ previousMonthMaxDays() - ( firstDayOfMonth - blank ) }}</span>

					<span class="events-wrapper" v-if="getEventsForDay( previousMonthObj.format( 'Y' ) + '-' + previousMonthObj.format( 'MMMM' ) + '-' + ( previousMonthMaxDays() - ( firstDayOfMonth - blank ) ) )">

						<span v-for="( event, index ) in getEventsForDay( previousMonthObj.format( 'Y' ) + '-' + previousMonthObj.format( 'MMMM' ) + '-' + ( previousMonthMaxDays() - ( firstDayOfMonth - blank ) ) )" class="event">
							<span v-if="( index + 1 ) <= eventIconsPerDay" :class="[{ 'event-icon': true, 'fully-booked' : event.fully_booked }, event.organiser]"></span>
						</span>

						<span v-if="getEventsForDay( previousMonthObj.format( 'Y' ) + '-' + previousMonthObj.format( 'MMMM' ) + '-' + previousMonthMaxDays() - ( firstDayOfMonth - blank ) ).length > eventIconsPerDay" class="more-events-than-shown">
							<span class="plus"></span>
							<span class="more-count">
								<span class="text">{{ getEventsForDay( previousMonthObj.format( 'Y' ) + '-' + previousMonthObj.format( 'MMMM' ) + '-' + ( previousMonthMaxDays() - ( firstDayOfMonth - blank ) ) ).length - eventIconsPerDay }}</span>
							</span>
						</span>

					</span>

				</div>

				<div v-for="date in daysInMonth"
					 :ref="generateDayId( year + '-' + month + '-' + date )"
					 :class="{
						 'day-col': true,
						 'current-day': date == initialDate && month == initialMonth && year == initialYear,
						 'in-past': isDayInPast( year + '-' + month + '-' + date ),
						 'has-events': dayHasEvents( year + '-' + month + '-' + date ),
						 'viewing': isViewingDay( year + '-' + month + '-' + date ) && dayHasEvents( year + '-' + month + '-' + date ) }"
					 :title="dayHasEvents( year + '-' + month + '-' + date ) ? 'View Events' : ''"
					@click="! isDayInPast( year + '-' + month + '-' + date ) && ! isViewingDay( year + '-' + month + '-' + date  ) ? updateViewingDay( year + '-' + month + '-' + date ) : ''">

					<span class="day-num">{{ date }}</span>

					<span class="events-wrapper" v-if="getEventsForDay( year + '-' + month + '-' + date )">

						<span v-for="( event, index ) in getEventsForDay( year + '-' + month + '-' + date )" class="event">
							<span v-if="( index + 1 ) <= eventIconsPerDay" :class="[{ 'event-icon': true, 'fully-booked' : event.fully_booked }, event.organiser]"></span>
						</span>

						<span v-if="getEventsForDay( year + '-' + month + '-' + date ).length > eventIconsPerDay" class="more-events-than-shown">
							<span class="plus"></span>
							<span class="more-count">
								<span class="text">{{ getEventsForDay( year + '-' + month + '-' + date ).length -eventIconsPerDay }}</span>
							</span>
						</span>

					</span>

				</div>

				<div v-for="blank in nextMonthDaysToFill" class="day-col filler-day" @click.prevent="addMonth">

					<span class="day-num">{{ blank }}</span>

					<span class="events-wrapper" v-if="getEventsForDay( nextMonthObj.format( 'Y' ) + '-' + nextMonthObj.format( 'MMMM' ) + '-' + blank )">

						<span v-for="( event, index ) in getEventsForDay( nextMonthObj.format( 'Y' ) + '-' + nextMonthObj.format( 'MMMM' ) + '-' + blank )" class="event">
							<span v-if="( index + 1 ) <= eventIconsPerDay" :class="[{ 'event-icon': true, 'fully-booked' : event.fully_booked }, event.organiser]"></span>
						</span>

						<span v-if="getEventsForDay( nextMonthObj.format( 'Y' ) + '-' + nextMonthObj.format( 'MMMM' ) + '-' + blank ).length > eventIconsPerDay" class="more-events-than-shown">
							<span class="plus"></span>
							<span class="more-count">
								<span class="text">{{ getEventsForDay( nextMonthObj.format( 'Y' ) + '-' + nextMonthObj.format( 'MMMM' ) + '-' + blank ).length - eventIconsPerDay }}</span>
							</span>
						</span>

					</span>

				</div>

			</div>

		</div>

	</div>

</template>

<script>

	let moment = require( 'moment' );

	module.exports = {
		data : function () {
			return {
				loading: false,
				today: moment(),
				dateContext: moment(), // Will be changed so we can view other months
				days: [ 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday' ],
				events: {},
				eventIconsPerDay: 3,
				viewingDay: null,
			}
		},
		computed: {
			year: function() {
				return this.dateContext.format( 'Y' );
			},
			month: function() {
				return this.dateContext.format( 'MMMM' );
			},
			dateObj: function() {
				return this.dateContext;
			},
			previousMonthObj: function() {
				return moment( this.dateContext ).subtract( 1, 'month' );
			},
			nextMonthObj: function() {
				return moment( this.dateContext ).add( 1, 'month' );
			},
			daysInMonth: function() {
				return this.dateContext.daysInMonth();
			},
			isPastMonth() {
				return this.dateContext.isBefore( this.today );
			},
			currentDate: function() {
				return this.dateContext.get( 'date' );
			},
			firstDayOfMonth: function() {
				let firstDay = moment( this.dateContext ).subtract( ( this.currentDate - 1 ), 'days' );

				return firstDay.weekday();
			},
			nextMonthDaysToFill: function() {
				let daysInWeek = 6; // needs to be 6 as it is indexed from 0

				return daysInWeek - moment( this.dateContext ).endOf( 'month' ).weekday();
			},
			initialDate: function() {
				return this.today.get( 'date' );
			},
			initialMonth: function() {
				return this.today.format( 'MMMM' );
			},
			initialYear: function() {
				return this.today.format( 'Y' );
			},
			initialDateObj: function() {
				return this.today;
			},
			disablePreviousMonth: function() {
				return this.previousMonthObj.isBefore( moment(), 'month' ) && ! this.previousMonthObj.isSame( moment(), 'month' );
			},
			isCurrentMonth: function() {
				return this.dateObj.isSame( this.initialDateObj, 'month' );
			},
		},
		watch : {
			dateContext: function() {
				this.refreshEvents();
			}
		},
		mounted() {
			this.refreshEvents();
		},
		methods: {
			nextMonth: function() {
				return moment( this.dateContext ).add( 1, 'month' ).format( 'MMMM' );
			},
			previousMonth: function() {
				return moment( this.dateContext ).subtract( 1, 'month' ).format( 'MMMM' );
			},
			previousMonthMaxDays: function() {
				return moment( this.dateContext ).subtract( 1, 'month' ).daysInMonth();
			},
			addMonth: function() {
				this.removeDayColMargin();
				this.removeViewingDay();
				this.dateContext = moment( this.dateContext ).add( 1, 'month' );
			},
			subtractMonth: function() {
				if ( ! this.disablePreviousMonth ) {
					this.removeDayColMargin();
					this.removeViewingDay();
					this.dateContext = moment( this.dateContext ).subtract( 1, 'month' );
				}
			},
			goToThisMonth: function() {
				this.dateContext = moment();
			},
			isDayInPast: function( date ) {
				date = moment( date, 'Y-MMMM-D' );

				return date.isBefore( this.today, 'day' );
			},
			refreshEvents: function() {
				let firstDay = moment( this.dateContext ).subtract( ( this.currentDate - 1 ), 'days' ).weekday(),
					fromDate = firstDay !== 0 ? // If starts on sunday
						moment( this.dateContext ).subtract( 1, 'month' ).endOf( 'month' ).subtract( this.firstDayOfMonth - 1, 'days' ) : // Need to minus one day as is indexed from 0
						moment( this.dateContext ).startOf( 'month' ),
					toDate   = this.nextMonthDaysToFill ? // IF we are adding other dates from the next month
						moment( this.dateContext ).add( 1, 'month' ).startOf( 'month' ).add( ( this.nextMonthDaysToFill - 1 ), 'days' ) : // Need to minus one day as is indexed from 0
						moment( this.dateContext ).endOf( 'month' );

				this.updateEvents( fromDate, toDate );
			},
			updateEvents: function( fromDate, toDate ) {
				let data = {
					nonce: ScriptData.crate_get_events_nonce,
					action: 'crate_get_events',
					date_from: fromDate.format( 'Y-MM-DD' ),
					date_to: toDate.format( 'Y-MM-DD' ),
				};

				this.loading = true;

				jQuery.post( ScriptData.ajaxurl, data, ( response ) => {
					this.events  = response.events;
					this.loading = false;
				} );
			},
			getDayEventsIndex: function( date ) {
				return moment( date, 'Y-MMMM-DD' ).format( 'Y-MM-DD' );
			},
			getEventsForDay: function( date ) {
				let key = this.getDayEventsIndex( date );

				return this.events[key] ?? false;
			},
			monthHasEvents: function() {
				return Object.keys( this.events ).length !== 0;
			},
			updateViewingDay: function( day ) {
				let dateObj = moment( day, 'Y-MMMM-D' );

				this.viewingDay = {
					date: dateObj,
					events: this.getEventsForDay( day ),
				};

				this.moveViewingPanel( dateObj.format( 'Y-MMMM-DD' ) );
			},
			isViewingDay: function( day ) {
				if ( this.viewingDay ) {
					return this.viewingDay.date.format( 'Y-MMMM-D' ) === day
				} else {
					return false;
				}
			},
			hasViewingDay: function() {
				if ( ! this.viewingDay ) {
					return false
				}

				return !! this.viewingDay.events;
			},
			generateDayId: function( day ) {
				return moment( day, 'Y-MMMM-DD' ).format( 'Y-MMMM-DD' );
			},
			moveViewingPanel: function( toId ) {
				let $viewingPanel = jQuery( '#current-events-panel' ),
					$toElement    = jQuery( this.$refs[ toId ] );

				$viewingPanel.removeClass( 'moved' );
				$viewingPanel.addClass( 'moving' );

				this.removeDayColMargin();

				setTimeout( () => {
					$viewingPanel.css( 'top', $toElement.position().top + $toElement.outerHeight() );

					setTimeout( () => {
						$toElement.css( 'margin-bottom', $viewingPanel.outerHeight() );
					}, 100 );

					setTimeout( () => {
						$viewingPanel.removeClass( 'moving' );
						$viewingPanel.addClass( 'moved' );
					}, 300 );
				}, 400 );
			},
			removeViewingDay: function() {
				this.viewingDay = null
			},
			removeDayColMargin: function() {
				jQuery( '.day-col' ).css( 'margin-bottom', 0 );
			},
			dayHasEvents: function( day ) {
				return !! this.getEventsForDay( day );
			}
		}
	}

</script>